import axios from 'axios';
import {
  API_BASE_URL,
  POSTALCODE_COUNTRIES_FETCH,
  POSTALCODE_PROVINCES_FETCH,
  POSTALCODE_CITIES_FETCH,
  COURIERS_COST_POST,
  SHIPPING_POST,
  USER_HISTORY_SHIPPING,
  HISTORY_SHIPPING_UPDATE,
  AUTH_TOKEN_KEY,
  COURIER_PRICE_KEY,
  USER_SIZES_FETCH,
  USER_BANK_ACCOUNT_FETCH,
  SIZES_FETCH,
  USER_SIZE_POST,
  USER_SIZE_UPDATE,
  USER_BANK_ACCOUNT_POST,
  USER_BANK_ACCOUNT_UPDATE,
  FETCH_ALL_COURIER,
  SET_DEFAULT_ADDRESS,
  DELETE_SHIPPING_ADDRESS,
  FETCH_DISTRICT,
  POST_PICKUP_IDEXPRESS,
  PASSING_SALE_ID_EXPRESS,
  ALLOWED_PICKUP_IDEXPRESS,
  POST_CANCEL_PICKUP_IDEXPRESS,
  GET_SHIPPING_FEE_PICKUP_IDEXPRESS,
  GET_BANK_LIST
} from '../constants';
import fetch from '../utils/Api';
import moment from 'moment';
const ENDPOINT = '/postalcode';
const ENDPOINT_COURIER = '/couriers';

export const doFetchCountries = () => ({
  type: POSTALCODE_COUNTRIES_FETCH,
  payload: axios.get(`${API_BASE_URL}${ENDPOINT}/countries`)
    .then(responses => responses.data)
})

export const doFetchDistricts = (province, city) => ({
  type: FETCH_DISTRICT,
  payload: axios.get(`${API_BASE_URL}${ENDPOINT}/district`, { params: { province, city } })
    .then(responses => responses.data)
})

export const setDefaultAddress = (id) => ({
  type: SET_DEFAULT_ADDRESS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).put(`users/shipping/${id}/set_default`)
    .then(res => {
      return res.data
    })
})

export const deleteShippingAddress = (id) => ({
  type: DELETE_SHIPPING_ADDRESS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).delete(`users/shipping/${id}`)
    .then(res => {
      return res.data
    })
})

export const fetchAllCourier = () => ({
  type: FETCH_ALL_COURIER,
  payload: axios.get(`${API_BASE_URL}/couriers`)
    .then(res => res.data.data)
})

export const doFetchProvinces = (country) => ({
  type: POSTALCODE_PROVINCES_FETCH,
  payload: axios.get(`${API_BASE_URL}${ENDPOINT}/province`, { params: { country } })
    .then(responses => responses.data)
})

export const doFetchCities = (country, province) => ({
  type: POSTALCODE_CITIES_FETCH,
  payload: axios.get(`${API_BASE_URL}${ENDPOINT}/city`, { params: { country, province } })
    .then(responses => responses.data)
})

export const concatShippingId = payload => `${payload.courier}-${payload.country}-${payload.product_variant_id}-${payload.weight}-${payload.destination}`

export const doPostShippingCost = payload => ({
  type: COURIERS_COST_POST,
  payload: new Promise((resolve, reject) => {
    try {
      const getLocalCourierStr = localStorage.getItem(COURIER_PRICE_KEY);
      if (getLocalCourierStr && getLocalCourierStr !== '' && !payload.product_addon) {
        const getItem = (JSON.parse(atob(getLocalCourierStr)) || [])
          .find(item => item.id === concatShippingId(payload)
            && item.last_fetched && moment().diff(item.last_fetched, 'minutes') < 30);
        if (getItem) return resolve(getItem)
      }
      axios.post(`${API_BASE_URL}${ENDPOINT_COURIER}`, payload)
        .then(responses => resolve({
          ...responses.data,
          isNew: true,
          country: payload.country,
          product_variant_id: payload.product_variant_id,
          destination: payload.destination,
          courier: payload.courier,
          weight: payload.weight
        }))
        .catch(e => reject(e));
    }
    catch (e) {
      localStorage.removeItem(COURIER_PRICE_KEY);
      return reject(e)
    };
  }).then(data => data)
})

export const getHistoryShipping = () => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: "USER_HISTORY_SHIPPING_PENDING"
      })

      fetch({
        Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
      })
        .get("/users/shipping")
        .then((res) => {
          resolve(
            dispatch({
              type: "USER_HISTORY_SHIPPING_FULFILLED",
              payload: res.data
            })
          )
        })
        .catch((err) => {
          reject(
            dispatch({
              type: "USER_HISTORY_SHIPPING_REJECTED",
              payload: err
            })
          )
        });
    })
};

export const saveRekening = (dataUserBankAccount, payload) => {
  const { account_name, account_number, bank_name, password, branch } = payload;
  return dispatch => {
    return new Promise((res, rej) => {
      if (dataUserBankAccount.data.length < 1 && dataUserBankAccount.status_code === 200) {
        res(dispatch(postUserBankAccount({ account_name, account_number, bank_name, password, branch })));
      } else if (dataUserBankAccount.data.length > 0 && dataUserBankAccount.status_code === 200) {
        const id = dataUserBankAccount.data[0].id;
        res(dispatch(updateUserBankAccount(id, payload)));
      } else {
        rej('Unverified user can\'t add a bank account, please verify your email first.');
      }
    });
  }
}

export const postUserBankAccount = (payload) => ({
  type: USER_BANK_ACCOUNT_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/bank/account`, payload)
    .then(res => {
      return res.data
    }).catch(err => {
      const errors = err.response.data.error.errors;
      // throw Object.keys(errors).map(key => errors[key][0])[0];
      throw err;
    })
})

export const updateUserBankAccount = (id, payload) => ({
  type: USER_BANK_ACCOUNT_UPDATE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).put(`${API_BASE_URL}/users/bank/account/${id}`, payload)
    .then(res => {
      return res.data
    })
})

export const saveUserSize = (size_id, dataUserSize) => {
  return dispatch => {
    if (dataUserSize.data.length < 1 && dataUserSize.status_code === 200) {
      dispatch(postUserSize({ size_id }));
    }
    else if (dataUserSize.data.length > 0 && dataUserSize.status_code === 200) {
      const id = dataUserSize.data[0].id;
      dispatch(updateUserSize(id, { size_id }));
    }
  }
}

export const postUserSize = (size_id) => ({
  type: USER_SIZE_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/sizes`, size_id)
    .then(res => {
      return res.data
    })
})

export const updateUserSize = (id, size_id) => ({
  type: USER_SIZE_UPDATE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).put(`${API_BASE_URL}/users/sizes/${id}`, size_id)
    .then(res => {
      return res.data
    })
})

export const saveShipping = (payload) => {
  const { id, alias, full_name, phone_number, street_address, country, city, province, note, postal_code, district } = payload;
  return dispatch => {
    if (payload.id === '')
      dispatch(postShipping({ alias, full_name, phone_number, street_address, country, city, province, note, postal_code, district }));
    else
      dispatch(updateHistoryShipping(id, { alias, full_name, phone_number, street_address, country, city, province, note, postal_code }));
  }
}

export const updateHistoryShipping = (id, payload) => ({
  type: HISTORY_SHIPPING_UPDATE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).put(`${API_BASE_URL}/users/shipping/${id}`, payload)
    .then(res => {
      return res.data
    })
})

export const postShipping = (payload) => ({
  type: SHIPPING_POST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/shipping`, payload)
    .then(res => {
      return { ...res.data, isNew: true }
    })
})

export const doFetchUserSizes = () => ({
  type: USER_SIZES_FETCH,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).get(`${API_BASE_URL}/users/sizes`)
    .then(res => {
      return res.data
    })
})

export const doFetchUserBankAccount = () => ({
  type: USER_BANK_ACCOUNT_FETCH,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).get(`${API_BASE_URL}/users/bank/account`)
    .then(res => {
      return res.data
    })
})

export const doFetchSizes = () => ({
  type: SIZES_FETCH,
  payload: axios.get(`${API_BASE_URL}/sizes?brand_id=null`)
    .then(res => {
      return res.data
    })
})

export const postPickUpIdExpress = (payload) => ({
  type: POST_PICKUP_IDEXPRESS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/idexpress/orders`, payload)
    .then(res => {
      return { ...res.data, isNew: true }
    })
})

export const passingSaleForIdExpress = (payload) => ({
  type: PASSING_SALE_ID_EXPRESS,
  payload
})

export const fetchPickupIDExpressSettings = () => ({
  type: ALLOWED_PICKUP_IDEXPRESS,
  payload: axios.get(`${API_BASE_URL}/settings?keyword=idexpress`)
    .then(res => {
      return res.data
    })
})

export const postCancelPickUpIdExpress = (payload) => ({
  type: POST_CANCEL_PICKUP_IDEXPRESS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/idexpress/cancel`, payload)
    .then(res => {
      return { ...res.data, isNew: true }
    })
})

export const getShippingFee = (payload) => ({
  type: GET_SHIPPING_FEE_PICKUP_IDEXPRESS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  }).post(`${API_BASE_URL}/users/idexpress/shipping-fee`, payload)
    .then(res => {
      return { ...res.data, isNew: true }
    })
    .catch(err => err)
})

export const getBankList = () => ({
  type: GET_BANK_LIST,
  payload: fetch().get("beneficiary-banks")
    .then((res) => res.data)
})

export const resetBankAndAddress = () => ({
  type: 'RESET_BANK_ADDRESS',
});
